import { useCallback, useEffect, useRef, useState } from "react";
import { fetchOpdReferrals } from "../api/registrationService";

export function useOpdReferrals() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  const load = useCallback(async ({ silent = false } = {}) => {
    if (mountedRef.current && !silent) {
      setLoading(true);
      setError(null);
    }
    try {
      const data = await fetchOpdReferrals();
      if (mountedRef.current) {
        setReferrals(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      if (mountedRef.current) {
        if (!silent) {
          setError(err.message || "Failed to load OPD referred patients");
        }
        setReferrals([]);
      }
    } finally {
      if (mountedRef.current && !silent) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    load();
    return () => { mountedRef.current = false; };
  }, [load]);

  return {
    referrals,
    loading,
    error,
    refresh: load,
  };
}
